import fireb from "../firebase/fireBase"
import configureStore from '../store/configureStore'
import { staticQuery } from "./handleDb"
import { uniquePreviewId } from "./appConfig"

const db = fireb.firestore()

const restoreAppPreview = async (appid, data) => {
    const appPreviewRef = db.collection('appsPreview').doc(appid)

    await appPreviewRef
        .get()
        .then(docSnapshot => {
            if (!docSnapshot.exists) {
                console.error('No se encuentra appsPreview!')
                // appPreviewRef.set(data)
            }
        })
}

const myAppsList = async (uid) => {

    return await db.collection('apps')
        .where('ownerid', '==', uid)
        .get()
        .then(res => {
            let applist = [], dataArr = []
            res.forEach(d => {
                dataArr.push(d.data())
                applist.push({
                    name: d.data().name,
                    id: d.data().appid,
                    owner: d.data().owner,
                    plan: d.data().plan,
                    paymentId: d.data().paymentId,
                })
            })

            configureStore.dispatch({
                type: 'SET_MY_APPS',
                payload: applist
            })

            return dataArr
        })

}

//This function gets the apps thad we are authorized to co-admin

const myAuthorizedApps = async (applist) => {

    let promises = []


    if (applist.length > 0) {
        applist.forEach(list => {
            promises.push(
                staticQuery(
                    'apps',
                    [{
                        field: 'appid',
                        operator: '==',
                        value: list.app
                    }]
                )
            )
        })
    }

    return await Promise.all(promises)
        .then(data => data.flat())
        .then(apps => {
            let applist = []
            apps.forEach(d => {
                applist.push({
                    name: d.name,
                    id: d.appid,
                    owner: d.owner,
                    authorized: true
                })
            })
            configureStore.dispatch({
                type: 'SET_MY_AUTH_APPS',
                payload: applist
            })

            return apps
        })
}

//This function set the app thad the user is editing at this moment
const setSelectedApp = (applist, appid, uid) => {
    let batch = db.batch()

    let selected = applist.filter(d => d.appid === appid)
    let noselected = applist.filter(d => d.appid !== appid)

    uniquePreviewId(appid)

    noselected.forEach(d => {
        if (d.appid) {
            if (d.ownerid === uid) {
                let Ref = db.collection('apps').doc(d.appid)
                batch.update(Ref, { 'selected': false })
            } else {
                let Ref = db.collection('users').doc(uid)
                batch.update(Ref, {
                    'selectedApp': ''
                })
            }
        }
    })

    selected.forEach(d => {
        if (d.appid) {
            if (d.ownerid === uid) {
                let Ref = db.collection('apps').doc(d.appid)
                batch.update(Ref, { 'selected': true })
            } else {
                let Ref = db.collection('users').doc(uid)
                batch.update(Ref, { 'selectedApp': appid })
            }
        }
    })

    return batch.commit()
        .catch(error => console.error('Aqui fue!' + error))
}

const handleCategories = (item, type, currentList, dispatch) => {

    let currentCategories = currentList
    let newCategories

    if (type === 'add') {
        newCategories = currentCategories.concat([item])
    } else {
        let index = currentCategories.indexOf(item);
        if (index > -1) {
            newCategories = currentCategories
            newCategories.splice(index, 1);
            if (!newCategories) {
                newCategories = []
            }
        }
    }

    configureStore.dispatch({
        type: dispatch,
        payload: newCategories
    })

}

const generateAppShortId = appid => {

    const firts = appid.substring(0, 3).toLowerCase()
    const last = appid.substring(14, 16).toLowerCase()

    return firts + last
}

export {
    restoreAppPreview,
    myAppsList,
    myAuthorizedApps,
    setSelectedApp,
    handleCategories,
    generateAppShortId
}